import { Flex, IconButton } from '@components';
import {
  useDeleteNomineeAgentMutation,
  useSendNomineeEmailVerificationRequestMutation,
  useSendNomineePasswordResetRequestMutation,
} from '@features/api/nomineeAgentSlice';
import { DeleteOutline, MoreVert } from '@mui/icons-material';
import { CircularProgress, Menu, MenuItem, useTheme } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

export interface ActionsMenuProps {
  agentId: number;
}

export const ActionsMenu = ({ agentId }: ActionsMenuProps) => {
  const theme = useTheme();

  const [deleteMutation] = useDeleteNomineeAgentMutation();
  const [
    sendEmailVerificationMutation,
    { isLoading: isLoadingEmailVerification },
  ] = useSendNomineeEmailVerificationRequestMutation();
  const [sendPasswordResetMutation, { isLoading: isLoadingPasswordReset }] =
    useSendNomineePasswordResetRequestMutation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleResendVerificationEmail = async () => {
    await sendEmailVerificationMutation({ nomineeAgentId: agentId }).unwrap();
  };
  const handleResetPassword = async () => {
    await sendPasswordResetMutation({ nomineeAgentId: agentId }).unwrap();
  };
  const handleDelete = async () => {
    await deleteMutation({ nomineeAgentId: agentId }).unwrap();
  };

  return (
    <>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-haspopup='true'
        onClick={handleClick}
        icon={MoreVert}
        color='info'
      />
      <Menu
        MenuListProps={{
          'aria-labelledby': 'long-button',
          sx: {
            minWidth: 220
          }
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          key='resend-confirmation-email'
          onClick={handleResendVerificationEmail}
        >
          {isLoadingEmailVerification ? (
            <Flex flex={1} justifyContent='center'>
              <CircularProgress color='primary' size='1em' />
            </Flex>
          ) : (
            <FormattedMessage id='agents.resendVerificationEmail' />
          )}
        </MenuItem>

        <MenuItem key='reset-password' onClick={handleResetPassword}>
          {isLoadingPasswordReset ? (
            <Flex flex={1} justifyContent='center'>
              <CircularProgress color='primary' size='1em' />
            </Flex>
          ) : (
            <FormattedMessage id='agents.resetPassword' />
          )}
        </MenuItem>

        <MenuItem
          key='delete'
          onClick={handleDelete}
          sx={{
            color: theme.palette.error.main,
          }}
        >
          <Flex gap={4}>
            <FormattedMessage id='agents.delete' />
            <DeleteOutline color='error' />
          </Flex>
        </MenuItem>
      </Menu>
    </>
  );
};
